import { Resolution } from '@/modules/shared/types';
import type { WidgetConfig } from '@/modules/ctx-dashboard';
import { WidgetType } from '@/modules/ctx-dashboard';
import type { WidgetPreset } from '@/components/widget-wizard';

export default class CustomScatterChart implements WidgetPreset {

    public readonly name: string = 'custom-stacked-generatorchart';
    public readonly type: WidgetType = WidgetType.StackedGeneratorChart;
    public readonly quickAdd: boolean = false;
    public readonly order: number = 20;
    public readonly metrics: string[] = [];

    public async createWidget(params: { portfolio: string; dashboard: string }): Promise<WidgetConfig> {
        return {
            key: '',
            portfolioKey: params.portfolio,
            dashboardKey: params.dashboard,
            order: 0,
            config: {
                apexConfig: {
                    chart: {
                        stacked: true,
                        stackType: 'normal',
                    },
                },
            },
            type: this.type,
            preset: this.name,
            title: '',
            generatedTitle: '',
            intervalName: 'this-month-complete',
            intervalTo: new Date(),
            intervalFrom: new Date(),
            resolution: Resolution.Automatic,
            axis: [{
                unit: '',
                name: '',
                metrics: [],
                config: {},
            }],
        };
    }
}
